<div class="modal-header py-2">
    <h2 class="mb-0">Upgrading price plan</h2>
    <span class="icon icon-cross ml-auto py-1 px-2" (click)="response(false)"></span>
</div>
<div class="modal-body">
    <p *ngIf="isPremiumPlan()">
      You are about to change your plan. You will get access to {{ accountFeatures}} features of the Premium plan.
      Your monthly message limit will be {{ pricePlan.limit | number }} messages. You will be charged
      <strong>{{ (pricePlan.price / 100) | currency: 'USD' : 'symbol' : '1.0-0' }}</strong>
      now.
      <span>Any time left on your current plan will be pro rated against this amount.</span>
    </p>
</div>
<div class="modal-footer">
    <button
        type="submit"
        class="btn btn-primary mr-2"
        angularticsCategory="account"
        angulartics2On="click"
        angularticsAction="Confirm Upgrade"
        [disabled]="blockActions"
        (click)="response(true)"
    >Confirm</button>
    <button type="button" class="btn btn-danger" [disabled]="blockActions" (click)="response(false)">Cancel</button>
</div>
